import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Card projectile",
  "description": "",
  "published": "2007-04-03T00:00:00.000Z",
  "redirect_from": ["/blog/card-projectile/swizec/245"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last night an idea came over me to learn how to throw cards and so I went in search of information online because as we all know information on anything can be found online. I have to say that I've fallen in love with it even though I'm still hardly able to make the cards fly with any kind of proper speed let alone having hte ability of targeting. It's still fun to do and I advise anyone to gie it a try as a means of dealing with stress.`}</p>
    <p>{`There are mastors of this art whom I will most likely never match in skill and achievement. One such is the amazing `}<a parentName="p" {...{
        "href": "http://www.rickyjay.com/"
      }}>{`Ricky jay`}</a>{`. He is just bloody awesome and I sugget you go ahve a look at some videos of him on youtube. I guarantee you will be`}<a parentName="p" {...{
        "href": "http://youtube.com/watch?v=HFAzKv8_XF4"
      }}>{` stunned`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      